<div class="fx-layout-row fx-layout-align-center-center">
  <div class="fx-flex-80pc">
    <p-dialog header="Certificate" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
      [style]="{width: '500px'}" (visibleChange)="handleClose()">

      <div class="red-text" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert-success" *ngIf="successMessage">{{ successMessage }}</div>

      <div *ngIf="!loading && !certificate">
        <p>Certificate Not Issued</p>
      </div>

      <div class="ui-g ui-fluid" *ngIf="!loading && certificate">
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="certName">Certificate Name*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="certName" [(ngModel)]="certName" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label>Certificate Date</label>
          </div>
          <div class="ui-g-8 pad0">
            <label>{{ certificate.cert_dt | date: 'shortDate' }}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label>Download Count</label>
          </div>
          <div class="ui-g-8 pad0">
            <label>{{ certificate.download_count }} / {{ certificate.max_downloads }}</label>
          </div>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button type="button" pButton (click)="goBack()" label="Back" class="left"></button>
          <button type="button" pButton *ngIf="!loading && certificate" (click)="save()" [disabled]="!certName"
            label="Save"></button>
        </div>
      </ng-template>
    </p-dialog>
  </div>
</div>
